var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import RcTooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { classNames, getFontInMac } from './../../common/className';
const Tooltip = (_a) => {
    var { overlay, children, placement = 'bottom', trigger = 'hover', overlayClassName, mouseEnterDelay } = _a, rest = __rest(_a, ["overlay", "children", "placement", "trigger", "overlayClassName", "mouseEnterDelay"]);
    if (overlay) {
        return (React.createElement(RcTooltip, Object.assign({ overlayClassName: classNames(getFontInMac(), overlayClassName), placement: placement, trigger: trigger, overlay: overlay, mouseEnterDelay: mouseEnterDelay || 0.1 }, rest), children));
    }
    else {
        return children || null;
    }
};
export default Tooltip;
